export interface IAvailableDays {
  sun: boolean
  mon: boolean
  tue: boolean
  wed: boolean
  thu: boolean
  fri: boolean
  sat: boolean
}

export interface IKitchenInfo {
  title: string
  values: string[]
}

export interface IMenuEntry {
  id: number
  categoryId: number
  title: string
  unitSellCode: number | null
  imageUrl: string | null
  kitchenInfo: IKitchenInfo[] | null
  price: number
  isFixed?: boolean
  count?: number
  allergens?: IAllergen[]
  allergenLabels?: string[]
  note?: string | null
  hasProductInfo?: boolean
}

export interface IMenu {
  id: number
  parentProductCategoryId: number
  name: string
  min: number
  max: number
  availableDays: IAvailableDays
  items: IMenuEntry[]
}

export interface IDietItem {
  code: string
  label: string
}

export interface IAllergen {
  id: number
  label: string
}

export interface IMenuItem {
  productId: number
  name: string
  count?: number
  price?: number
  menuIndex?: number
  recordGuid?: string
  isApplyDiscount?: boolean
}

// QRM-640: declaration runs + nutrient table served by GET /product-info.
// Runs are styled text segments ("\n" = paragraph break) — never HTML.
export interface IRichRun {
  text: string
  bold?: boolean
  italic?: boolean
  underline?: boolean
}

export interface INutrientRow {
  code: string
  label: string
  amount: number | null // null = header row like "davon:"
  unit: string
}

export interface IProductInfo {
  declaration: IRichRun[] | null
  nutrients: INutrientRow[]
}

export interface IProduct {
  id: number
  categoryId: number
  title: string
  price: number
  imageUrl: string | null
  kitchenInfo: IKitchenInfo[] | null
  menus: IMenu[]
  innerCategoryItems: IProduct[]
  unitSellCode: number | null
  allergens: IAllergen[]
  allergenLabels: string[]
  dietItems: IDietItem[]
  availableDays: IAvailableDays
  amount?: number
  note?: string | null
  youthProtectionValue?: string | null
  ClickCollectOrderMin?: number | null
  ClickCollectOrderMax?: number | null
  ClickCollectLeadDaysCount?: number | null
  hasProductInfo?: boolean
  soldOut?: boolean
}

export interface ICategory {
  id: number
  name: string
  availableDays: IAvailableDays
  products: IProduct[]
}

export interface ICatalog {
  items: ICategory[]
  soldOutIds: number[]
  isLoaded: boolean
  isLoading: boolean
}

export const initialState: ICatalog = {
  items: [],
  soldOutIds: [],
  isLoaded: false,
  isLoading: false,
}
